import { DefaultHeaderTitleProviderService } from '@addins/core/home';
import { Injectable } from '@angular/core';
import { GuidTools } from '@models/guid';
import { Task } from '@models/imported/SagaSchema/Task';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UnitActivityMDP } from '../../models/UnitActivityMDP';

@Injectable({
  providedIn: 'root'
})
export class MissionHeaderTitleProviderService extends DefaultHeaderTitleProviderService {
  protected get myUnit(): UnitActivityMDP {
    return super.myUnit as UnitActivityMDP;
  }

  private myTask: Task = null;
  private myTaskChangedSub: Subscription = null;

  protected onUnitDestroyed() {
    super.onUnitDestroyed();

    this.myTaskChangedSub?.unsubscribe();
    this.myTaskChangedSub = null;
    this.myTask = null;
  }

  protected updateCallCard() {
    if (GuidTools.isValid(this.myUnit.TaskID)) {
      if (this.myCallcard) {
        this.myCallcardChangedSub?.unsubscribe();
        this.myCallcardChangedSub = null;
        this.myCallcard = null;
      }

      const isDifferentTask: boolean = this.myTask === null || this.myTask.ObjGuid !== this.myUnit.TaskID;
      if (isDifferentTask) {
        this.myTask = this.cacheService.getObjectByUid(this.myUnit.TaskID);
        this.myTaskChangedSub?.unsubscribe();
        this.myTaskChangedSub = this.cacheService
          .listenForChange(Task)
          .pipe(filter(cacheEvent => (cacheEvent.object as Task).ObjGuid === this.myTask.ObjGuid))
          .subscribe(() => this.updateUnitStatus());
      }
    } else if (GuidTools.isValid(this.myUnit.CallCardID)) {
      if (this.myTask) {
        this.myTaskChangedSub?.unsubscribe();
        this.myTaskChangedSub = null;
        this.myTask = null;
      }
      super.updateCallCard();
    } else {
      super.updateCallCard();
      this.myTaskChangedSub?.unsubscribe();
      this.myTaskChangedSub = null;
      this.myTask = null;
    }
  }

  protected getStatusExtraInfo(): string {
    return this.myTask ? this.myTask.Name : super.getStatusExtraInfo();
  }
}
